import React from "react";
import { t } from "i18next";
import moment from "moment";
import swal from "sweetalert";

import {
   Button,
   Form,
   Modal,
   InputDate,
   InputTextArea,
   Radio,
   SelectInput
} from "common/elements";
import { createOvertimeRequest } from "services/overtime_request";
import { Util } from "common/util";


export default class FormInsertOrUpdate extends React.PureComponent {
   isGrantedForPayment = Util.getInstance().hasPermission("request for payment", "overtime request");
   isGrantedForLeave = Util.getInstance().hasPermission("request for leave", "overtime request");

   state = {
      visible: false,
      loading: false,
      type: ""
   }

   showModal = () => {
      this.setState({
         visible: true,
      });

   }

   handleCancel = () => {
      this.setState({
         visible: false,
      });
      this.props.form.resetFields();
   };

   getStartDate = (startDate, startShift) => {
      let startTime = "08:00";

      if (startShift === "PM") {
         startTime = "13:00";
      }

      return moment(`${startDate.format("YYYY-MM-DD")} ${startTime}`);
   }

   getEndDate = (endDate, startShift) => {
      let endTime = "17:00";

      if (startShift === "AM") {
         endTime = "12:00";
      }

      return moment(`${endDate.format("YYYY-MM-DD")} ${endTime}`);
   }

   onChangeType = (event) => {
      this.setState({type: event.target.value});
   }

   onChangeStartDate = (startDate) => {
      let endDate = this.props.form.getFieldValue("endDate");

      const startShift = this.props.form.getFieldValue("startDateTime");
      const endShift = this.props.form.getFieldValue("endDateTime");

      if (startDate) {
         startDate = this.getStartDate(startDate, startShift);
      }

      this.props.form.setFieldsValue({startDate});

      if (endDate == null && startDate) {
         endDate = this.getEndDate(startDate, endShift);
         this.props.form.setFieldsValue({ endDate });
      }
   }

   onChangeEndDate = (endDate) => {
      const endShift = this.props.form.getFieldValue("endDateTime");

      if (endDate) {
         endDate = this.getEndDate(endDate, endShift);
         this.props.form.setFieldsValue({endDate});
      }
   }

   onChangeStartTime = () => {
      const startDate = this.props.form.getFieldValue("startDate");
      this.onChangeStartDate(startDate);
   }

   onChangeEndTime = () => {
      const endDate = this.props.form.getFieldValue("endDate");
      this.onChangeEndDate(endDate);
   }

   onFinish = (values) => {
      values["employeeId"] = Util.getInstance().getCurrentUser().id;
      values["startDate"] = values.startDate.format("YYYY-MM-DD HH:mm");
      values["endDate"] = values.endDate.format("YYYY-MM-DD HH:mm");
      
      if (!(this.isGrantedForLeave && this.isGrantedForPayment)) {
         if (this.isGrantedForPayment) values["type"] = "FOR_PAYMENT";
         if (this.isGrantedForLeave) values["type"] = "FOR_LEAVE";
      }
      
      this.setState({ loading: true });
      createOvertimeRequest(values)
      .then(() => {
         this.handleCancel();
         this.props.onSuccess();
      })
      .catch((error) => {
         if (error?.response?.status === 400) {
            if(error?.response?.data?.error?.message){
               swal({
                  title: "Duplicate Overtime Request Detected",
                  text: error?.response?.data?.error?.message,
                  icon: "error",
                  dangerMode: true,
               });
            }
            
         }
      })
      .finally(() => {
         this.setState({ loading: false });
      });
   };

   render() {
      const {
         visible,
         loading
      } = this.state;

      return visible ? (
         <Modal
            title={"New Overtime Request"}
            visible={visible}
            onCancel={this.handleCancel}
         >
            <Form
               form={this.props.form}
               onFinish={this.onFinish}
               layout="vertical"
               key={"overtime-request"}
            >
               {
                  (this.isGrantedForPayment && this.isGrantedForLeave) && 
                  <Form.Item
                     name="type"
                     label="Type"
                     onChange={this.onChangeType}
                     rules={[
                        {
                           required: true,
                           message: "Please select type!"
                        }
                     ]}
                  >
                     <Radio.Group>
                        {
                           this.isGrantedForPayment && 
                           <Radio value="FOR_PAYMENT">For Payment</Radio>
                        }
                        {
                           this.isGrantedForLeave && 
                           <Radio value="FOR_LEAVE">For Compensation</Radio>
                        }
                     </Radio.Group>
                  </Form.Item>
               }
               <div style={{ display: "flex" }}>
                  <InputDate
                     name="startDate"
                     label={"OT From"}
                     required={true}
                     allowClear={true}
                     errorMessage={t("text_please_select_ot_from")}
                     format="ddd DD MMM, YYYY"
                     placeholder={"ddd DD MMM, YYYY"}
                     style={{ width: 292 }}
                     onChange={this.onChangeStartDate}
                     disabledDate={current => ((this.props.form.getFieldValue("endDate") && current > moment(this.props.form.getFieldValue("endDate"))))}
                  />
                  <SelectInput
                     name="startDateTime"
                     label={" "}
                     initialValue={"AM"}
                     disabled={(this.isGrantedForPayment && (!this.isGrantedForLeave)) || this.state.type === "FOR_PAYMENT"}
                     valueKey="id"
                     dataSource={[
                        { id: "AM", name: "AM" },
                        { id: "PM", name: "PM" },
                     ]}
                     style={{ width: 80, marginLeft: 0, marginRight: 0 }}
                     onChange={this.onChangeStartTime}
                  />
               </div>
               
               <div style={{ display: "flex" }}>
                  <InputDate
                     name="endDate"
                     label={"OT To"}
                     format="ddd DD MMM, YYYY"
                     placeholder={"ddd DD MMM, YYYY"}
                     required={true}
                     allowClear={true}
                     errorMessage={t("text_please_select_ot_to")}
                     disabledDate={current => (this.props.form.getFieldValue("startDate") && current < moment(this.props.form.getFieldValue("startDate")))}
                     style={{ width: 292 }}
                  />
                  <SelectInput
                     name="endDateTime"
                     label={" "}
                     initialValue={"PM"}
                     disabled={(this.isGrantedForPayment && (!this.isGrantedForLeave))  || this.state.type === "FOR_PAYMENT"}
                     valueKey="id"
                     dataSource={[
                        { id: "AM", name: "AM" },
                        { id: "PM", name: "PM" },
                     ]}
                     style={{ width: 80, marginLeft: 0, marginRight: 0 }}
                     onChange={this.onChangeEndTime}
                  />
               </div>

               <InputTextArea
                  name="reason"
                  label={t("text_reason")}
                  rows={2}
                  required={true}
                  placeholder={"Please tell us about reason of taking OT"}
                  requiredMessage={"Please tell us about reason of taking OT"}
               />

               <div className="ant-modal-footer2">
                  <Button
                     className="btn-cancel"
                     onClick={this.handleCancel}
                     disabled={loading}
                  >
                     {t("text_cancel")}
                  </Button>
                  <Button
                     className="btn-save"
                     type="primary"
                     htmlType="submit"
                     disabled={loading}
                     loading={loading}
                  >
                     {t("text_submit")}
                  </Button>
               </div>
            </Form>
         </Modal>
      )
         :
         <div />;
   }
}